<template>
  <span id="app">
    <v-tooltip bottom>
      <template #activator="{ on }">
        <template v-if="iconButton">
          <v-btn
            color="primary"
            small
            fab
            v-on="on"
            @click="visualizarDocumento()"
          >
            <v-icon class="white--text">{{ icon }}</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-chip
            v-on="on"
            :outlined="outlined"
            :dark="dark"
            label
            small
            @click="visualizarDocumento()"
            color="primary"
            class="py-4 my-1 mr-2"
            :text="text"
          >
            <v-icon small class="mr-1">{{ icon }}</v-icon>
            <span>
              {{ textButton }}
            </span>
          </v-chip>
        </template>
      </template>
      <span>Clique para visualizar o documento em .PDF</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      width="80%"
      scrollable
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar dark color="primary lighten-1" elevation="0" tile>
          <v-toolbar-title> {{ textTitle }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col style="background-color: rgb(82, 86, 89)">
              <div v-if="obj" v-html="obj"></div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
let downloadjs = require("downloadjs");

export default {
  props: {
    textButton: { type: String },
    iconButton: { type: Boolean, default: false },
    icon: { type: String },
    text: { type: Boolean, default: false },
    textTitle: { type: String },
    outlined: { type: Boolean, default: true },
    dark: { type: Boolean, default: false },
    idarqcas: { type: String }
  },
  data() {
    return {
      dialog: false,
      obj: null,
      selected: null,
      flagSelected: false
    };
  },
  methods: {
    download() {
      Vue.axios({
        method: "get",
        url: process.env.VUE_APP_URL + "/cas/forseti/base64/" + this.idarqcas,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        downloadjs(atob(response.data), "boletim", "application/pdf");
      });
    },
    visualizarDocumento() {
      this.dialog = true;
      this.showDocumento();
    },
    async showDocumento() {
      try {
        const response = await Vue.axios({
          method: "get",
          url: process.env.VUE_APP_URL + "/cas/forseti/base64/" + this.idarqcas,
          headers: {
            "Content-Type": "application/json"
          }
        });

        this.obj = document.createElement("object");
        this.obj.style.width = "100%";
        this.obj.style.height = window.innerHeight - 269 + "pt";
        this.obj.type = "application/pdf";

        let file = this.base64toBlob(response.data, "application/pdf");
        let fileURL = URL.createObjectURL(file);

        this.obj.data = fileURL;
        this.obj = this.obj.outerHTML;
      } catch (error) {
        console.log(error);
        this.obj =
          '<div style="text-align: center; color: white;">Erro ao carregar o documento.</div>';
      }
    },
    base64toBlob(base64Data, contentType) {
      contentType = contentType || "";
      let byteCharacters = atob(base64Data);
      let bytesLength = byteCharacters.length;
      let sliceSize = 1024;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);

      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);

        let bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    }
  }
};
</script>
